// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/report-options2/simple-filter-v3/simple-filter-v3.component.css
// module id = 477
// module chunks = 0